// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3xMw0","rootSmall":"AddTileButton_rootSmall__3ck35"};